<template>
  <div>
    <v-main>
      <div class="bg">
        <v-container>
          <div class="center nav">
            <h2 style="margin-bottom: 0">Sign Up</h2>
          </div>
          <div class="signUp">
            <div class="center" style="padding-bottom: 1rem">
              <v-btn
                dark
                large
                block
                style="background: #25388d"
                class="btn-mail"
                to="/createAccount"
              >
                <v-icon style="padding-right: 10px">mdi-email</v-icon>
                Sign Up with Email</v-btn
              >
            </div>
            <div class="center" style="padding-bottom: 1rem">
              <v-btn
                large
                block
                style="background: var(--neutral-white, #fff)"
                class="btn-google"
                to="/createAccount"
                ><img
                  style="width: 20px; height: 20px; margin: 0 10px"
                  :src="require('@/assets/icons8-google-48.png')"
                  alt=""
                />
                Sign Up with Google</v-btn
              >
            </div>
            <div class="center" style="padding-bottom: 1rem">
              <v-btn dark block large style="background: #0056b2" class="btn-face" @click="loginWithFacebook"
                ><v-icon style="padding-right: 10px">facebook</v-icon> Sign Up
                with Facebook</v-btn
              >
            </div>
          </div>
          <div class="footer">
            <div class="center" style="padding-bottom: 1.5rem">
              <span>Already have an account? <a href="##">Login</a></span>
            </div>
            <div class="center" style="text-align: center">
              <span
                >By BeTask, you agree to the
                <a href="##">Terms of Services</a> &
                <a href="##">Privacy Policy</a>.</span
              >
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'LoyaltySystemSignUp',

  data () {
    return {}
  },

  mounted () {
    window.fbAsyncInit = function () {
    /* global FB */
      FB.init({
        appId: '579746187441654',
        cookie: true,
        xfbml: true,
        version: 'v17.0'
      })

      FB.AppEvents.logPageView()
    };

    (function (d, s, id) {
      // eslint-disable-next-line one-var
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) { return }
      js = d.createElement(s); js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  },

  methods: {
    openRegister () {
      window.location = 'http://localhost:8081/createAccount'
    },
    loginWithFacebook () {
      console.log('aaa')
      FB.login(
        response => {
          if (response.authResponse) {
            const userId = response.authResponse.userID
            console.log('Facebook user ID:', userId)
          } else {
            console.log('ผู้ใช้ยกเลิกการเข้าสู่ระบบหรือไม่อนุญาต')
          }
        },
        { scope: 'public_profile,email' }
      )
    }
  }
}
</script>

<style scoped>
/*//////////////*/
.bg {
  background: var(--neutral-grey-5, #eef3fc);
  height: 100vh;
  display: flex;
  justify-content: center;
}
.center {
  display: flex;
  justify-content: center;
}
span {
  color: var(--neutral-grey-2, #858494);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
a {
  text-decoration: none;
  color: var(--color-primary, #25388d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.nav {
  display: flex;
  align-items: center;
  height: 100px;
}
.nav div {
  display: flex;
  align-items: center;
}
.iconn {
  display: flex;
  align-items: center;
}

.signUp {
  justify-content: center;
}
.btn-mail {
  border-radius: 20px;
  width: 327px;
  height: 56px;
  color: #fff !important;
}
.btn-google {
  border-radius: 20px;
  border: 2px solid var(--neutral-grey-4, #e6e6e6);
  width: 327px;
  height: 56px;
  /* color: #fff !important; */
}
.btn-face {
  border-radius: 20px;
  display: flex;
  width: 327px;
  padding: 16px 133px;
  justify-content: center;
  align-items: center;
  height: 56px;
  color: #fff !important;
}
.v-btn:not(.v-btn--round).v-size--large {
    height: 56px;
    min-width: 78px;
    padding: 0 19.5555555556px;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/signUp.vue